import React, { Component } from "react";

import { CButton } from "@coreui/react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { setLayout } from "../../actions/layoutActions";
import { setObj } from "../../actions/noteActions";
import Interface from "../../components/Interface";
import URL from "../../config/api";

class Child extends Component {
  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.props.setLayout(false);
  }

  render() {
    return (
      <div
        className="w-100 h-100"
        style={{ position: "absolute", top: 0, left: 0 }}
      >
        <CButton
          color="danger"
          style={{
            position: "absolute",
            top: "1rem",
            right: "1rem",
            zIndex: 100
          }}
          onClick={() => this.props.history.goBack()}
        >
          <i className="fa fa-chevron-left mr-2"></i> Voltar
        </CButton>
        <Interface modal={false} botoes={0} url={`${URL.public}ef1/`} />
      </div>
    );
  }
}

Child.propTypes = {
  hideLayout: PropTypes.bool,
  guestLogin: PropTypes.bool
};

Child.defaultProps = {
  hideLayout: true,
  guestLogin: false
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setObj,
      setLayout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Child);
